import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="order-table"
export default class extends Controller {
  static targets = [
    "row",
    "rateInput",
    "discountInput",
    "textInput",
    "dateInput",
    "uptimeSelect",
    "slaCiscoTypeSelect",
    "slaCiscoSlaSelect"
  ];

  connect() {
    this.formatAllNumbers();
    console.log("order-table connected");
  }

  // ---- 再計算関連 ----
  recalc(event) {
    const tr = event.target.closest("tr");
    this.calculateRow(tr);
  }

  calculateRow(tr) {
    const getVal = (selector) => {
      const el = tr.querySelector(selector);
      if (!el) return 0;
      if (el.tagName === "INPUT" || el.tagName === "SELECT") {
        return el.value ? el.value.replace(/,/g, "") : 0;
      } else {
        return el.textContent ? el.textContent.replace(/,/g, "") : 0;
      }
    };

    // ---- 期間計算 ----
    const startedAt = new Date(tr.querySelector("[id$=_started_at]").value);
    const endedAt = new Date(tr.querySelector("[id$=_ended_at]").value);
    const mth = parseInt((endedAt - startedAt) / 2592000000);
    tr.querySelector("[id$=_mth]").value = mth;

    const days = parseInt((endedAt - startedAt) / 86400000);

    // ---- 基本値の取得 ----
    const qty = parseFloat(getVal("[name=qty]")) || 0;

    // product_price_glp は <span name="product_price_glp"> から取得
    const product_price_glp =
      parseFloat(getVal("span[name='product_price_glp']")) || 0;

    // total_service_price_glp は hidden_field
    const total_service_price_glp =
      parseFloat(getVal("[name$='[total_service_price_glp]']")) || 0;

    const cisco_discount =
      parseFloat(getVal("[name$='[cisco_discount]']")) || 0;

    // ---- Cisco計算 ----
    const ciscoBeforeDiscount =
      Math.round((total_service_price_glp / 365) * (days + 1) * 100) / 100;
    const cisco =
      Math.round(ciscoBeforeDiscount * (100 - cisco_discount)) / 100;
    tr.querySelector("[name=cisco]").textContent = cisco.toLocaleString();

    // ---- NESIC計算 ----
    const nesic_rate = parseFloat(getVal("[name$='[nesic_rate]']")) || 0;

    const nesic =
      Math.round(product_price_glp * (nesic_rate / 100) * qty * 100) / 100;

    const nesicInput = tr.querySelector("[name$='[nesic]']");
    if (nesicInput) nesicInput.value = nesic;

    const nesic_jpy = Math.round((nesic / 12) * mth * 100);
    const nesicJpyInput = tr.querySelector("[name$='[nesic_jpy]']");
    if (nesicJpyInput) nesicJpyInput.value = nesic_jpy.toLocaleString();

    const bot_rate = parseFloat(getVal("[name$=bot_rate]")) || 0;
    const nesic_usd = bot_rate
      ? Math.round((nesic_jpy / bot_rate) * 100) / 100
      : 0;

    const nesicUsdInput = tr.querySelector("[name$='[nesic_usd]']");
    if (nesicUsdInput) nesicUsdInput.value = nesic_usd.toLocaleString();

    // ---- コスト計算 ----
    const direct_cost = cisco + nesic_usd;
    const directCostInput = tr.querySelector("[name$='[direct_cost]']");
    if (directCostInput) directCostInput.value = direct_cost.toLocaleString();

    const ohc_rate = parseFloat(getVal("[name$='[ohc_rate]']")) || 0;
    const ohc_cost = Math.round(direct_cost * ohc_rate) / 100;
    const ohcCostInput = tr.querySelector("[name$='[ohc_cost]']");
    if (ohcCostInput) ohcCostInput.value = ohc_cost.toLocaleString();

    const total_cost = Math.round((direct_cost + ohc_cost) * 100) / 100;
    const totalCostInput = tr.querySelector("[name$='[total_cost]']");
    if (totalCostInput) totalCostInput.value = total_cost.toLocaleString();

    // ---- 販売価格計算 ----
    const gp_rate = parseFloat(getVal("[name$='[gp_rate]']")) || 0;
    const preferred_sales_price =
      Math.round((total_cost / (100 - gp_rate)) * 100 * 100) / 100;
    const preferredSalesInput = tr.querySelector(
      "[name$='[preferred_sales_price]']"
    );
    if (preferredSalesInput)
      preferredSalesInput.value = preferred_sales_price.toLocaleString();
  }

  // ---- 数値フォーマット ----
  formatAllNumbers() {
    this.textInputTargets.forEach((el) => {
      if (!el.value) return;
      el.value = parseFloat(el.value.replace(/,/g, "")).toLocaleString();
    });
    this.element.querySelectorAll("span[name]").forEach((el) => {
      if (!el.textContent) return;
      el.textContent = parseFloat(
        el.textContent.replace(/,/g, "")
      ).toLocaleString();
    });
  }

  handleFocus(event) {
    const el = event.target;
    el.value = el.value.replace(/,/g, "");
  }

  handleBlur(event) {
    const el = event.target;
    if (el.value) {
      el.value = parseFloat(el.value.replace(/,/g, "")).toLocaleString();
    }
  }

  // ---- 日付変更 ----
  changeDate(event) {
    const tr = event.target.closest("tr");
    this.calculateRow(tr);
  }

  // ---- Uptime変更によるAjax ----
  async changeUptime(event) {
    const select = event.target;
    const id = select.value;
    console.log("works");
    if (!id) return;

    const response = await fetch(`/uptimes/${id}`, {
      headers: { Accept: "application/json" }
    });
    const data = await response.json();
    console.log(data);
    const td = select.closest("td");
    td.nextElementSibling.textContent = data.direct_code;
    td.nextElementSibling.nextElementSibling.textContent = data.sap_code;
  }

  // ---- Cisco SLA 選択 ----
  changeSlaCiscoType(event) {
    const tr = event.target.closest("tr");
    const slaSelect = tr.querySelector("[name$='[sla_cisco_sla]']");
    slaSelect.value = "";
    tr.querySelector("[id$=_service_sku_text]").textContent = "";
    tr.querySelector("[id$=_cisco_discount]").value = 0;
  }

  async changeSlaCiscoSla(event) {
    const tr = event.target.closest("tr");
    const sku = tr.querySelector("td:nth-child(3)").textContent;
    const qty = parseFloat(tr.querySelector("td:nth-child(8)").textContent);
    const cisco_service_type = tr.querySelector(
      "[id$=_cisco_service_type]"
    ).value;
    const cisco_sla = tr.querySelector("[id$=_sla_cisco_sla]").value;

    const response = await fetch(
      `/slas/scan?q[sku]=${sku}&q[cisco_service_type]=${cisco_service_type}&q[cisco_sla]=${cisco_sla}`,
      {
        headers: { Accept: "application/json" }
      }
    );

    const service = await response.json();
    if (service) {
      tr.querySelector("td[id$=_service_sku_text]").textContent = service.sku;
      tr.querySelector("[id$=_service_id]").value = service.id;
      tr.querySelector("[id$=_total_service_price_glp]").value =
        service.usd * qty;
      tr.querySelector(
        "td[id$=_total_service_price_glp_text]"
      ).textContent = ` $${(service.usd * qty).toLocaleString()}`;
      tr.querySelector("[id$=_cisco_discount]").value = parseInt(
        service.cisco_discount
      );
      this.calculateRow(tr);
    } else {
      tr.querySelector("[id$=_service_sku_text]").textContent = "No Service!";
      tr.querySelector("[id$=_total_service_price_glp_text]").textContent =
        "$0";
      tr.querySelector("[id$=_total_service_price_glp]").value = 0;
      tr.querySelector("[id$=_cisco_discount]").value = 0;
      this.calculateRow(tr);
    }
  }

  // ---- 送信時にカンマ除去 ----
  sanitizeOnSubmit(event) {
    this.textInputTargets.forEach((el) => {
      el.value = el.value.replace(/,/g, "");
    });
  }
}
